"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64Encode = void 0;
function base64Encode(str) {
    if (typeof Buffer === "function") {
        // Node.js environment
        return Buffer.from(str).toString("base64");
    }
    else if (typeof btoa === "function") {
        // Browser environment
        return btoa(str);
    }
    else {
        throw new Error("Base64 encoding not supported in this environment.");
    }
}
exports.base64Encode = base64Encode;
